<template>
    <div class="form">
        <div class="row">
            <div class="col">
                <p class="paragraph">Select the Electric Vehicle you're interested in:</p>
            </div>
        </div>
        <div class="row row__select">
            <div class="col-md-6 col-12">
                <div class="pretty-radio">
                    <label :for="`car`" class="label label--radio d-inline-block">
                        <input type="radio"
                               v-model="vehicleType"
                               :id="`car`"
                               :name="`vehicle-select`"
                               :value="`car`"
                               class="input input--radio"/>
                        <span class="pretty-radio__check">Car</span>
                    </label>
                    <label :for="`van`" class="label label--radio d-inline-block">
                        <input type="radio"
                               v-model="vehicleType"
                               :id="`van`"
                               :name="`vehicle-select`"
                               :value="`van`"
                               class="input input--radio"/>
                        <span class="pretty-radio__check">Van</span>
                    </label>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="pretty-select">
                    <select v-model="selectedVehicle">
                        <option value="0" selected disabled>-- Please select a vehicle</option>
                        <option v-for="vehicle in vehicleList" :value="vehicle.id" :key="vehicle.name">{{vehicle.name}}</option>
                    </select>
                </div>
                <span class="error" v-if="selectorError">{{selectorError}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {VEHICLE_TYPE, SELECTED_VEHICLE} from "../store/mutation-types";

    export default {
        name: "VehicleSelector",
        computed:{
            vehicleType: {
                get: function() {
                    return this.$store.state.VEHICLE_TYPE;
                },
                set: function(value) {
                    this.$store.commit(SELECTED_VEHICLE, {id:0});
                    this.$store.commit(VEHICLE_TYPE, value)
                }
            },
            vehicleList: function(){
                return this.$store.getters.vehicles;
            },
            selectedVehicle: {
                get: function() {
                    return this.$store.state.SELECTED_VEHICLE.id
                },
                set: function(value) {
                    let selected = this.$store.getters.vehicles.filter(function(val){
                        return val.id === value;
                    });
                    this.$store.commit(SELECTED_VEHICLE, selected[0]);
                }
            },
            selectorError: function() {
                if(this.$store.state.ERRORS.vehicleSelect) {
                    return this.$store.state.ERRORS.vehicleSelect;
                }
                return false;
            }
        }
    }
</script>

<style scoped lang="stylus">
    .form
        flex-direction: column
        margin-right 0
        flex-wrap nowrap
        .row
            &__select
                margin-bottom 0.5rem
        .paragraph
            @media (max-width 767px)
                margin-bottom 1rem
        .pretty-radio
            flex 0 0 100%
            display flex
            justify-content flex-start
            align-items center
            padding 9px 0
            @media (max-width 767px)
                flex-wrap wrap
                margin-bottom 1rem

            &__title
                margin-right 1.5rem

                @media (max-width 767px)
                    flex 0 0 100%
                    margin-bottom 5px
            &__check
                &:before
                    background-color $color-white

            .paragraph
                margin-right 2.5rem
                display: inline-block
                margin-bottom 0

            .label--radio
                flex 0 0 auto
                max-width unset
                display flex
                position relative
                overflow hidden
                flex-direction row
                justify-content flex-start
                align-items center
                padding-left 3.5rem
                padding-right 0
                cursor pointer
                margin 0

                &:not(:last-child)
                    margin-right 4.5rem

                .input
                    position absolute
                    left -9999em
                    max-width auto
                    width auto

                // check markers

                span
                    &:before
                        display block
                        position absolute
                        left 0
                        top 50%
                        transform translateY(-50%)
                        content ''
                        width 2.4rem
                        height 2.4rem
                        border solid 1px #a8adb3
                        box-shadow none
                        border-radius 50%
                        cursor pointer

                .input:checked + span
                    &:after
                        display block
                        position absolute
                        left 5px
                        top 50%
                        transform translateY(-50%)
                        content ''
                        width 1.4rem
                        height 1.4rem
                        box-shadow none
                        background-color $color-blue-petrol
                        border-radius 50%
                        cursor pointer

        .pretty-select
            border solid 1px $color-grey-border
            background-color $color-white
            &:after
                background-image url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='9' viewBox='0 0 15 9'%3E%3Cpath fill='%23004666' fill-rule='nonzero' d='M1.588.03l5.883 5.882L13.41-.03l1.56 1.558-7.5 7.5L.029 1.59 1.59.028z'/%3E%3C/svg%3E")
                background-color $color-white
                background-repeat no-repeat
                background-position 50% 50%

        .error
            margin-top 1rem
            color $color-red
            font-size 1.3rem
</style>